function isObject ( value: any ): boolean {
    return value !== null && value !== undefined && typeof value === 'object'
}

function isUndefined ( value: any ): boolean {
    return typeof value === 'undefined'
}

export {
    isObject,
    isUndefined
}